import TreePicker from './app.vue';
export default TreePicker;


// WEBPACK FOOTER //
// ./src/index.js